<template>
  <v-menu
    v-model="menu"
    bottom
    right
    transition="scale transition"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-hover v-slot="{ hover }">
        <span
          :elevation="hover ? 12 : 2"
          :class="{ 'on-hover': hover, 'hover-block': true }"
        >
          <v-chip
            small
            :close="close"
            close-icon="close"
            label
            outlined
            class="mr-2 px-1"
            :color="hover ? 'primary' : ''"
            @click="menu = true"
            @click:close="$emit('delete', tag)"
            v-on="on"
          >
            {{ tag.title }}
          </v-chip>
        </span>
      </v-hover>
    </template>
    <v-card>
      <v-card-text>
        <v-row align-center>
          <v-text-field
            v-model="tag.title"
            label="Редагування тега"
            :hide-details="true"
            class="ma-2"
          />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          :loading="loading"
          :disabled="!tag.title || tag.title === value.title"
          @click="update(tag)"
        >
          ОК
        </v-btn>
        <v-btn
          text
          @click="cancel"
        >
          Відміна
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
import * as tagsApi from "../../backend/tagsApi.js";
export default {
  props: ["value", "close"],
  data: () => ({
    menu: false,
    loading: false,
    tag: null,
    tagOld: null,
  }),
  watch: {
    value: {
      handler(val) {
        if (!val) {
          return;
        }
        this.tag = { ...val };
      },
      immediate: true,
    },
  },
  created() {
    this.tagOld = { ...this.value };
  },
  methods: {
    async update(value) {
      try {
        this.loading = true;
        await tagsApi.updateTag(value.id, value.title);
        this.$emit("update", value);
      } catch (err) {
        this.$notifyWarning(err.response.data);
        this.tag = { ...this.tagOld };
      } finally {
        this.loading = false;
        this.menu = false;
      }
    },
    cancel() {
      this.menu = false;
      this.tag = { ...this.value };
      this.tagOld = null;
    },
  },
};
</script>
